<template>
    <div class="page-wrapper">
        <change-password-window
                :visible="changePasswordWindow.visible"
                @close-window="closeChangePasswordWindow"/>
        <Header/>
        <div class="wrapper">
            <div class="page">
                <div class="container col2">
                    <div class="container-left">
                        <UserMenu/>
                    </div>
                    <div class="container-right">
                        <div class="login-form profile-form">
                            <div class="page-title">Профиль</div>
                            <div class="form">
                                <fieldset>
                                    <div class="gradient-border">
                                        <div class="left"></div>
                                        <div class="right"></div>
                                        <input v-model.trim="user.name"
                                               name="username"
                                               ref="username"
                                               type="text"
                                               autocomplete="off"
                                               required
                                        >
                                        <label>Ваше имя *</label>
                                    </div>
                                </fieldset>
                                <fieldset>
                                    <div class="gradient-border">
                                        <div class="left"></div>
                                        <div class="right"></div>
                                        <input v-model.trim="user.email"
                                               name="email"
                                               type="text"
                                               autocomplete="off"
                                               required
                                               v-validate="'required|email'"
                                        >
                                        <label>Email *</label>
                                        <span v-show="errors.has('email')">{{ errors.first('email') }}</span>
                                    </div>
                                </fieldset>
                                <fieldset>
                                    <div class="gradient-border">
                                        <div class="left"></div>
                                        <div class="right"></div>
                                        <date-picker
                                                v-model="user.birthday"
                                                format="DD.MM.YYYY"
                                                lang="ru"
                                                v-mask="'##.##.####'"
                                                placeholder="дд.мм.гггг"
                                                value-type="date"
                                                :input-attr="{ id: 'datePicker', required: 'true' }"
                                                :clearable="false"
                                                :first-day-of-week="1">
                                            <template slot="calendar-icon">&nbsp;</template>
                                        </date-picker>
                                    </div>
                                </fieldset>
                                <fieldset>
                                    <div class="gradient-border">
                                        <div class="left"></div>
                                        <div class="right"></div>
                                        <date-picker
                                                v-model="user.birthtime"
                                                type="time"
                                                format="HH:mm"
                                                lang="ru"
                                                v-mask="'##:##'"
                                                placeholder="чч:мм"
                                                value-type="format"
                                                :minute-step="1"
                                                :input-attr="{ id: 'timePicker', required: 'true' }"
                                                :clearable="false">
                                            <template slot="calendar-icon">&nbsp;</template>
                                        </date-picker>
                                    </div>
                                </fieldset>
                                <fieldset>
                                    <div class="gradient-border">
                                        <div class="left"></div>
                                        <div class="right"></div>
                                        <city-picker
                                                v-model="user.birthAddress"
                                                :forward-value="true"/>
                                    </div>
                                </fieldset>
                                <fieldset>
                                    <div class="gradient-border">
                                        <div class="left"></div>
                                        <div class="right"></div>
                                        <city-picker
                                                v-model="user.currentAddress"
                                                :forward-value="true"
                                                :label="'Место нахождения'"/>
                                    </div>
                                </fieldset>
                                <div class="center">
                                    <button type="button" class="button blue-button"
                                            :disabled="!inputDataValid"
                                            @click="sendSaveProfileDataRequest">Сохранить
                                    </button>
                                </div>
                            </div>
                            <div class="change-password">
                                <span @click="showChangePasswordWindow"><i class="fa fa-lock"></i>Изменить пароль</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-buffer"></div>
        </div>
        <Footer/>
    </div>
</template>

<script>
    import constants from '@/constants';
    import nativeDom from '@/native-dom.js';
    import utils from '@/utils';
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    import UserMenu from '@/components/UserMenu';
    import CityPicker from '@/components/CityPicker';
    import {Validator} from 'vee-validate';
    import {mask} from 'vue-the-mask';
    import DatePicker from 'vue2-datepicker';
    import moment from 'moment';
    import ChangePasswordWindow from '@/components/window/ChangePasswordWindow';

    export default {
        name: "Profile",

        directives: {mask},

        components: {
            Header, Footer, UserMenu, CityPicker, DatePicker, ChangePasswordWindow
        },

        data() {
            return {
                user: {
                    name: '',
                    username: '',
                    email: '',
                    birthday: '',
                    birthtime: '',
                    birthAddress: {},
                    currentAddress: {}
                },

                changePasswordWindow: {
                    visible: false
                }
            }
        },

        computed: {
            inputDataValid() {
                return this.user.name && this.user.name.length > 0
                        && this.user.email && this.user.email.length > 0
                        && !this.errors.has('email');
            }
        },

        created() {
            this.loadUserDataFromStore();
        },

        mounted() {
            Validator.localize('en', constants.dictionary);

            nativeDom.initLabelForDatePicker();
            nativeDom.initLabelForTimePicker();
        },


        methods: {
            loadUserDataFromStore() {
                let currentUser = this.$store.getters.currentUser;

                let birthday;
                let birthtime;
                if (!!currentUser.birthday || currentUser.birthday == 0) {
                    birthday = new Date(moment(currentUser.birthday).set({
                        hour: 0,
                        minute: 0,
                        second: 0,
                        millisecond: 0
                    }).valueOf());
                    birthtime = moment(currentUser.birthday).format("HH:mm");
                } else {
                    birthday = null;
                    birthtime = null;
                }

                Object.assign(this.user, {
                    name: currentUser.name,
                    username: currentUser.username,
                    email: currentUser.email,
                    birthday: birthday,
                    birthtime: birthtime,
                    birthAddress: currentUser.birthAddress,
                    currentAddress: currentUser.currentAddress
                });
            },

            async sendSaveProfileDataRequest() {
                if (!this.inputDataValid)
                    return;

                let birthday = utils.getUnixTimeOfBirthdateAndTime(this.user.birthday, this.user.birthtime);

                let userData = Object.assign({}, this.user);
                Object.assign(userData, {
                    birthday: birthday
                });

                try {
                    let success = await this.$store.dispatch('updateUserData', userData);
                    if (!!success) {
                        alert('Данные сохранены!');
                        this.loadUserDataFromStore();
                    }
                } catch (error) {
                }
            },

            showChangePasswordWindow() {
                this.changePasswordWindow.visible = true;
            },

            closeChangePasswordWindow() {
                this.changePasswordWindow.visible = false;
            }
        }
    }
</script>